import { get, merge } from 'lodash';
import { findCompany, findGrouping } from '../../helpers/companies';

import * as syncActionCreators from '../sync/index';

export function getCompany(id, callback) {
  return simpleIsoFetch => (dispatch, getState) => {
    const groups = getState().staticData.companyStatusGroups;
    simpleIsoFetch.get(`/api/companies/${id}`)
      .then(({body: {data: {items: [company]}}}) =>
        findGrouping({company, groups})
      )
      .then((data) => callback(null, data))
      .catch(callback);
  };
}

export function goToPage(skip, limit, terms, filters) {
  return simpleIsoFetch => (dispatch) =>
    simpleIsoFetch.get({
      route: '/api/companies',
      query: {
        terms,
        ...filters,
        skip,
        limit,
      }
    })
    .then((data) => {
      dispatch(syncActionCreators.updateCompaniesPage(data.body.data));
    })
    .catch(err => console.error(err));
}

export function getCompanyJobs(id, callback) {
  return simpleIsoFetch => (dispatch) => {
    return simpleIsoFetch.get(`/api/companies/${id}/jobs`)
      .then((data) => callback(null, data))
      .catch(callback);
  };
}

export function getCompanyContacts(id, callback) {
  return simpleIsoFetch => (dispatch) => {
    return simpleIsoFetch.get(`/api/companies/${id}/contacts`)
      .then((data) => {
         if(callback)
            callback(null, data)

        return data;
      })
      .catch(err => {
         if(callback)
           return callback(err);
         return Promise.reject(err);
      });
  };
}

export function addCompanyContacts(body, callback) {
  return simpleIsoFetch => dispatch => {
    return simpleIsoFetch.post({route: `/api/companies/${body.profile.companyId}/contacts`, body})
      .then((resp) => {
        if(callback) {
          return callback(null, resp.body.data.items[0])
        }
        return resp.body.data.items[0];
      })
      .catch(err => {

        if(callback)
          return callback(err.body);
        return Promise.reject(err.body);
      });
  };
}


export function updateCompanyContact(body, callback) {

  return simpleIsoFetch => dispatch => {
    return simpleIsoFetch.put({route: `/api/companies/${body.profile.companyId}/contacts/${body.profile.id}`, body})
      .then((resp) => {
          if(callback)
            return callback(null, resp.body.data.items[0].profileId)

          return resp.body.data.items[0].profileId;
      })
      .catch(err => {
         if(callback)
           return callback(err);
         return Promise.reject(err.body.errors);
      });
  };
}

export function updateContactsByCompanyId({id, fields} = {}) {
  return simpleIsoFetch => dispatch => {
    return simpleIsoFetch.put({route: `/api/companies/${id}/contacts`, body: fields})
    .then((data) => {
      return data;
    })
    .catch((err) => {
      console.error('[contacts actionCreator] error with updateContactsByCompanyId route', err);
    });
  };
}

export function deleteCompanyContact(companyId, contactId, callback) {

  return (simpleIsoFetch) =>
    () => {

      return simpleIsoFetch.del(`/api/companies/${companyId}/contacts/${contactId}`)
        .then(resp => get(resp, 'body.data'))
        .then(data => data ? callback(null, data) : Promise.reject(new Error('Invalid response')))
        .catch(err => callback(get(err, 'body.errors', [err])))
      ;

    }
  ;

}

export function updateCompany(newCompany, callback) {
  return simpleIsoFetch => (dispatch, getState) => {
    const {id = 0} = newCompany;
    const groups = getState().staticData.companyStatus;
    const store = getState().admin.companies;
    const current = findCompany({id}, store);
    return simpleIsoFetch.put(`/api/companies/${id}`, {
      body: newCompany
    })
    .then(() => merge({}, current, newCompany))
    .then((company) => findGrouping({company, groups}))
    .then((data) => {
      if (callback) return callback(null, data);

      return data;
    })
    .catch((err) => {
       if(callback)
          return callback(err)

      return Promise.reject(err.body.errors);
    });
  };
}

export function updateCompanyById(comp, callback) {
  return simpleIsoFetch => (dispatch, getState) => {
    simpleIsoFetch.put(`/api/companies/${comp.id}`, {
        body: comp
      })
  .then((data) => callback(null, data))
  .catch(callback);
  };
}

export function updateCompanyStatus(id, companyStatus, callback) {
  return simpleIsoFetch => (dispatch, getState) => {
    const groups = getState().staticData.companyStatus;
    const store = getState().admin.companies;
    const current = findCompany({profile: {id}}, store);
    return simpleIsoFetch.put(`/api/companies/${id}/status/${companyStatus}`)
      .then(() => merge({}, current, {companyStatus }))
      .then(company => findGrouping({company, groups}))
      .then(data => callback ? callback(null, data) : data)
      .catch(err => callback ? callback(err) : Promise.reject(err));
  };
}


// Tech

export function getCompanyTech(id, callback) {
  return simpleIsoFetch => (dispatch) => {
    return simpleIsoFetch.get(`/api/companies/${id}/tech`)
      .then((resp) => callback(null, resp.body.data))
      .catch(callback);
  };
}

export function createCompanyTech(tech, callback) {
  return simpleIsoFetch => (dispatch, getState) => {
    simpleIsoFetch.post(`/api/companies/${tech.companyId}/tech`, {
        body: tech
      })
  .then((data) => callback(null, data))
  .catch(callback);
  };
}


export function updateCompanyTech(tech, callback) {
  return simpleIsoFetch => (dispatch, getState) => {
    simpleIsoFetch.put(`/api/companies/${tech.companyId}/tech`, {
        body: tech
      })
  .then((data) => callback(null, data))
  .catch(callback);
  };
}

export function deleteCompany(companyId, callback) {
  return (simpleIsoFetch) => () => {
    simpleIsoFetch.del(`/api/companies/${companyId}`)
      .then(data => callback && callback(null, data) || data)
      .catch(err => callback && callback(err) || Promise.reject(err))
    ;
  };
}



// WEBPACK FOOTER //
// ./shared/redux/actionCreators/async/companies.js